var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLongLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11H6.82998L9.70998 8.12001C10.1 7.73001 10.1 7.10001 9.70998 6.71001C9.31998 6.32001 8.68998 6.32001 8.29998 6.71001L3.70998 11.3C3.31998 11.69 3.31998 12.32 3.70998 12.71L8.29998 17.3C8.68998 17.69 9.31998 17.69 9.70998 17.3C10.1 16.91 10.1 16.28 9.70998 15.89L6.82998 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11Z",
    fill: "#282828"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongLeft);
export default __webpack_public_path__ + "static/media/ArrowLongLeft.9ea0d74b.svg";
export { ForwardRef as ReactComponent };